module.exports = __webpack_public_path__ + "img/back_300.aa7026eb.jpg";